import { Outlet, Link } from 'react-router-dom'
import { Brand } from '../../components/common/Brand'
export function PublicLayout() {
  return (
    <div className="public-shell">
      <header className="public-header">
        <Brand />
        <nav aria-label="Navigasi utama">
          <Link to="/">Utama</Link>
          <a href="/#tentang">Tentang</a>
          <Link className="button button--primary" to="/login">
            Log masuk
          </Link>
        </nav>
      </header>
      <main id="main-content">
        <Outlet />
      </main>
      <footer>
        <Brand variant="compact" />
        <p>Ruang rasmi untuk alumni S.A.F BESTARI kembali terhubung.</p>
        <small>© {new Date().getFullYear()} SAMBEST Alumni Federation</small>
      </footer>
    </div>
  )
}
